export const createResolverFactory = (
  resolve,
  resolveError = (e) => {
    throw e;
  }
) => {
  return ({ errors, ...resp }) => {
    return errors ? resolveError(errors) : resolve(resp);
  };
};

export default createResolverFactory;
